module.exports = __webpack_public_path__ + "48d77b600da8b4e834abf387000a3274.MP3";